import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    event : {},
    timerRunning: false,
    startTimer: false,
    timerExpire: false,
    timerPaused: false,
    timerResume:false,
    timerRestart: {
        restart: false,
        newExpiry: null,
        autoStart: true,
    },
    pageChanged: false,
    thinkTimeExpired: false,
    overrideText: "",
    janusRecording: false,
    janusError: false,
    paginationDisabled: false,
    checkReset:false,
    checkDeleted:false,
    showQuestionMenu: false,
    inRecording:false,
    timerLock:false,
    joyRideSkip:false,
    errorTour: false,
    autoPlay : null,
    interivewDoesNotExist:false,
    codingEditorTheme: "vs-dark",
    stopVoiceWriting: false,
    focusOnQuillEditor: false,
    pauseVideo:false
};

const eventSlice = createSlice({
    name:'event',
    initialState,
    reducers : {
        setEventData : (state, {payload}) => {
            state.event = payload;
        },
        setTimerRunning : (state, {payload}) => {
            state.timerRunning = payload;
        },
        setStartTimer : (state, {payload}) => {
            state.startTimer = payload;
        },
        setTimerExpire : (state, {payload}) => {
            state.timerExpire = payload;
        },
        setTimerPaused : (state, {payload}) => {
            state.timerPaused = payload;
        },
        setTimerRestart : (state, {payload}) => {
            state.timerRestart = payload;
        },
        setPageChanged : (state, {payload}) => {
            state.pageChanged = payload;
        },
        setThinkTimeExpired : (state, {payload}) => {
            state.thinkTimeExpired = payload;
        },
        setOverrideText : (state, {payload}) => {
            state.overrideText = payload;
        },
        setJanusRecording : (state, {payload}) => {
            state.janusRecording = payload;
        },
        setJanusError : (state, {payload}) => {
            state.janusError = payload;
        },
        setPaginationDisabled : (state, {payload}) => {
            state.paginationDisabled = payload;
        },
        setCheckReset : (state, {payload}) => {
            state.checkReset = payload;
        },
        setCheckDeleted : (state, {payload}) => {
            state.checkDeleted = payload;
        },
        setShowQuestionMenu : (state, {payload}) => {
            state.showQuestionMenu = payload;
        },
        setInRecording : (state, {payload}) => {
            state.inRecording = payload;
        },
        setTimerResume : (state, {payload}) => {
            state.timerResume = payload;
        },
        setTimerLock : (state, {payload}) => {
            state.timerLock = payload;
        },
        setJoyRideSkip : (state, {payload}) =>{
            state.joyRideSkip = payload;
        },
        setErrorTour: (state, {payload}) => {
            state.errorTour = payload;
        },
        setAutoPlay: (state, {payload}) => {
            state.autoPlay = payload;
        },
        setInterviewDoesNotExist:(state,{payload})=>{
            state.interivewDoesNotExist = payload
        },
        setCodingEditorTheme: (state, {payload})=>{
            state.codingEditorTheme = payload;
        },
        setStopVoiceWriting:(state,{payload})=>{
            state.stopVoiceWriting = payload;
        },
        setFocusOnQuillEditor:(state,{payload})=>{
            state.focusOnQuillEditor=payload;
        },
        setPauseVideo:(state,{payload})=>{
            state.pauseVideo=payload;
        }
    }
})

export const {
    setEventData, setTimerRunning, setStartTimer, setTimerExpire, setTimerPaused, setTimerRestart, setPageChanged, 
    setStartThinkTimer, setThinkTimerRestart, setThinkTimeExpired, setOverrideText, setJanusRecording, setJanusError, 
    setPaginationDisabled, setCheckReset, setCheckDeleted, setShowQuestionMenu, setInRecording, setTimerResume, setTimerLock, 
    setJoyRideSkip, setErrorTour, setAutoPlay,setInterviewDoesNotExist, setCodingEditorTheme, setStopVoiceWriting, setFocusOnQuillEditor,setPauseVideo} = eventSlice.actions;

export const getEventData = (state) => state.event.event;
export const getTimerRunning = (state) => state.event.timerRunning;
export const getStartTimer = (state) => state.event.startTimer;
export const getTimerExpire = (state) => state.event.timerExpire;
export const getTimerPaused = (state) => state.event.timerPaused;
export const getTimerResume = (state) => state.event.timerResume;
export const getTimerRestart = (state) => state.event.timerRestart;
export const getPageChanged = (state) => state.event.pageChanged;
export const getThinkTimeExpired = (state) => state.event.thinkTimeExpired;
export const getOverrideText = (state) => state.event.overrideText;
export const getJanusRecording = (state) => state.event.janusRecording;
export const getJanusError = (state) => state.event.janusError;
export const getPaginationDisabled = (state) => state.event.paginationDisabled;
export const getCheckReset = (state) => state.event.checkReset;
export const getCheckDeleted = (state) => state.event.checkDeleted;
export const getShowQuestionMenu = (state) => state.event.showQuestionMenu;
export const getInRecording = (state) => state.event.inRecording;
export const getTimerLock = (state) => state.event.timerLock;
export const getJoyRideSkip = (state) => state.event.joyRideSkip;
export const getErrorTour = (state) => state.event.errorTour;
export const getAutoPlay = (state) => state.event.autoPlay;
export const getInterviewDoesNotExist =(state)=>state.event.interivewDoesNotExist
export const getCodingEditorTheme = (state)=>state.event.codingEditorTheme;
export const getStopVoiceWriting = (state)=>state.event.stopVoiceWriting;
export const getFocusOnQuillEditor = (state)=>state.event.focusOnQuillEditor;
export const getPauseVideo =(state)=>state.event.pauseVideo;

export default eventSlice.reducer;